import React from 'react';
import Helmet from 'react-helmet';
import { Container, Stack, useMediaQuery, useTheme } from '@mui/material';
import { Navigate, Route, Routes } from 'react-router-dom';
import { Breadcrumbs, BurgerMenu, Header } from '../../components';
import { AdminMenu } from './AdminMenu';
import { AdminPlaceholder } from './AdminPlaceholder';
import { AdminUsers } from './AdminUsers';
import { AdminContentReports } from './AdminContentReports';
import { useIntl } from 'react-intl';

const pageStyles = { width: '100%', height: '100%' };

export const Admin = React.memo(() => {
  const intl = useIntl();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <div style={pageStyles}>
      <Helmet
        title={intl.formatMessage({
          id: 'admin.pageTitle',
          defaultMessage: 'Admin | Acolyte',
        })}
      />
      <Header mainIcon={isMobile && <BurgerMenu menu={<AdminMenu />} />} />
      <Container maxWidth="xl">
        <Stack direction="row">
          {!isMobile && <AdminMenu />}
          <Stack flexGrow={1} gap={1} minWidth={0}>
            <Breadcrumbs />
            <Routes>
              <Route index element={<Navigate replace to="users" />} />
              <Route path="users" element={<AdminUsers />} />
              <Route path="imports" element={<AdminPlaceholder />} />
              <Route path="activity" element={<AdminPlaceholder />} />
              <Route path="content-reports" element={<AdminContentReports />} />
            </Routes>
          </Stack>
        </Stack>
      </Container>
    </div>
  );
});
